// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bs-container {
  container-type: inline-size;
  /*min-width: 768px;*/
  font-family: 'Arial', 'Helvetica', 'Sans-serif';
  cursor: auto;
  height: 100%;
  display: flex;
  flex-direction: column;
}

/* Content wrapper for flex layout */
.bs-container .bs-content-wrapper {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-height: 0;
  height: 100%;
}

/* scrollable table container */
.bs-container .bs-table-container {
  margin-top: 20px;
  flex: 1 1 auto;
  min-height: 0;
}

.bs-container .bs-table {
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0px;
}

.bs-container .bs-table thead th {
  box-shadow: inset 0 -1px 0 0 var(--border-line);
  text-align: right;
  font-family: 'Arial', 'Helvetica', 'Sans-serif';
  font-weight: 700;
  padding: 0;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0;
  color: var(--text-subheader);
  vertical-align: bottom;
  white-space: nowrap;
}
.bs-container .bs-table thead th:nth-child(1) {
  /*padding:0px !important;    */
}
.bs-container .bs-table thead th:first-child {
  width: 22px;
  box-shadow: none;
}

.bs-container .bs-table thead th:last-child {
  width: 22px;
  box-shadow: none;
}

.bs-container .bs-table tbody td {
  vertical-align: middle;
  box-shadow: inset 0 -1px 0 0 var(--border-tertiary);
}

.bs-container .bs-table tbody td:first-child {
  width: 22px;
  border: none;
}

.bs-container .bs-table tbody td:last-child {
  width: 22px;
  border: none;
}
/*.bs-container .bs-table tbody tr:nth-child(2n) {
    background-color: #EFEFEF;
}    */

/* Table header styles */
.bs-table-header {
  padding: 8px 0;
  text-align: left;
  font-family: 'Arial', 'Helvetica', 'Sans-serif';
  font-size: 16px;
  color: var(--text-subheader);
}

.bs-currency-label {
  font-size: 12px;
  font-weight: 400;
  line-height: normal;
}

.bs-container .bs-table thead th.bs-table-header-year {
  text-align: right;
  padding: 0px 8px 8px 8px;
  min-width: 80px;
  max-width: 100px;
}

.bs-container .bs-table thead th.bs-table-header-label {
  text-align: left;
  padding: 0px 8px 8px 8px;
  min-width: 180px;
  max-width: 180px;
}

.bs-header-content {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 3px;
}

.bs-header-fy {
  font-weight: 700;
  font-size: 16px;
  line-height: 18px;
  color: var(--text-subheader);
}

.bs-header-date {
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
  color: var(--text-subheader);
}

/* Table body styles */
.bs-container .bs-table tbody td {
  font-family: 'Arial', 'Helvetica', 'Sans-serif';
  vertical-align: middle;
  text-align: right;
  font-size: 16px;
  padding: 0;
  line-height: 20px;
  letter-spacing: 0;
  color: var(--text-primary);
  box-sizing: border-box;
}

.bs-container .bs-table tbody td.bs-table-label-cell {
  text-align: left;
  padding-left: 8px;
  min-width: 180px;
  max-width: 180px;
}

.bs-container .bs-table tbody td.bs-table-cell {
  text-align: right;
  padding: 0 8px 0 0;
  min-width: 100px;
  max-width: 100px;
}

.bs-label-with-icon {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  user-select: none;
}

.bs-expand-icon {
  width: 16px;
  height: 16px;
  transition: transform 0.2s ease;
  transform: rotate(-90deg);
  flex-shrink: 0;
  color: var(--text-primary);
  path {
    fill: currentColor;
  }
}

.bs-expand-icon.expanded {
  transform: rotate(0deg);
}

.bs-label-text {
  font-size: 16px;
  line-height: 24px;
  color: var(--text-primary);
  font-weight: 700;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: block;
  max-width: 100%;
}

.bs-indented-label {
  font-size: 16px;
  line-height: 24px;
  padding-left: 32px !important;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.bs-cell-content {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  padding: 8px 0;
}

.bs-cell-value {
  font-size: 16px;
  line-height: 18px;
  color: var(--text-primary);
  height: 24px;
}

.bs-cell-growth {
  font-size: 14px;
  line-height: 100%;
  font-weight: 400;
  height: 16px;
}

.bs-cell-growth.positive {
  color: var(--text-up-color);
}

.bs-cell-growth.negative {
  color: var(--text-down-color);
}
`, "",{"version":3,"sources":["webpack://./src/Widgets/BalanceSheetWidget/BalanceSheetWidget.css"],"names":[],"mappings":"AAAA;EACE,2BAA2B;EAC3B,oBAAoB;EACpB,+CAA+C;EAC/C,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA,oCAAoC;AACpC;EACE,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,aAAa;EACb,YAAY;AACd;;AAEA,+BAA+B;AAC/B;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,+CAA+C;EAC/C,iBAAiB;EACjB,+CAA+C;EAC/C,gBAAgB;EAChB,UAAU;EACV,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,4BAA4B;EAC5B,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,8BAA8B;AAChC;AACA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,mDAAmD;AACrD;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;AACA;;MAEM;;AAEN,wBAAwB;AACxB;EACE,cAAc;EACd,gBAAgB;EAChB,+CAA+C;EAC/C,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA,sBAAsB;AACtB;EACE,+CAA+C;EAC/C,sBAAsB;EACtB,iBAAiB;EACjB,eAAe;EACf,UAAU;EACV,iBAAiB;EACjB,iBAAiB;EACjB,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,yBAAyB;EACzB,cAAc;EACd,0BAA0B;EAC1B;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,6BAA6B;EAC7B,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,0BAA0B;EAC1B,YAAY;AACd;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;AAC/B","sourcesContent":[".bs-container {\n  container-type: inline-size;\n  /*min-width: 768px;*/\n  font-family: 'Arial', 'Helvetica', 'Sans-serif';\n  cursor: auto;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\n/* Content wrapper for flex layout */\n.bs-container .bs-content-wrapper {\n  display: flex;\n  flex-direction: column;\n  flex: 1 1 auto;\n  min-height: 0;\n  height: 100%;\n}\n\n/* scrollable table container */\n.bs-container .bs-table-container {\n  margin-top: 20px;\n  flex: 1 1 auto;\n  min-height: 0;\n}\n\n.bs-container .bs-table {\n  width: 100%;\n  border-collapse: collapse;\n  border-spacing: 0px;\n}\n\n.bs-container .bs-table thead th {\n  box-shadow: inset 0 -1px 0 0 var(--border-line);\n  text-align: right;\n  font-family: 'Arial', 'Helvetica', 'Sans-serif';\n  font-weight: 700;\n  padding: 0;\n  font-size: 16px;\n  line-height: 24px;\n  letter-spacing: 0;\n  color: var(--text-subheader);\n  vertical-align: bottom;\n  white-space: nowrap;\n}\n.bs-container .bs-table thead th:nth-child(1) {\n  /*padding:0px !important;    */\n}\n.bs-container .bs-table thead th:first-child {\n  width: 22px;\n  box-shadow: none;\n}\n\n.bs-container .bs-table thead th:last-child {\n  width: 22px;\n  box-shadow: none;\n}\n\n.bs-container .bs-table tbody td {\n  vertical-align: middle;\n  box-shadow: inset 0 -1px 0 0 var(--border-tertiary);\n}\n\n.bs-container .bs-table tbody td:first-child {\n  width: 22px;\n  border: none;\n}\n\n.bs-container .bs-table tbody td:last-child {\n  width: 22px;\n  border: none;\n}\n/*.bs-container .bs-table tbody tr:nth-child(2n) {\n    background-color: #EFEFEF;\n}    */\n\n/* Table header styles */\n.bs-table-header {\n  padding: 8px 0;\n  text-align: left;\n  font-family: 'Arial', 'Helvetica', 'Sans-serif';\n  font-size: 16px;\n  color: var(--text-subheader);\n}\n\n.bs-currency-label {\n  font-size: 12px;\n  font-weight: 400;\n  line-height: normal;\n}\n\n.bs-container .bs-table thead th.bs-table-header-year {\n  text-align: right;\n  padding: 0px 8px 8px 8px;\n  min-width: 80px;\n  max-width: 100px;\n}\n\n.bs-container .bs-table thead th.bs-table-header-label {\n  text-align: left;\n  padding: 0px 8px 8px 8px;\n  min-width: 180px;\n  max-width: 180px;\n}\n\n.bs-header-content {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 3px;\n}\n\n.bs-header-fy {\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 18px;\n  color: var(--text-subheader);\n}\n\n.bs-header-date {\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 14px;\n  color: var(--text-subheader);\n}\n\n/* Table body styles */\n.bs-container .bs-table tbody td {\n  font-family: 'Arial', 'Helvetica', 'Sans-serif';\n  vertical-align: middle;\n  text-align: right;\n  font-size: 16px;\n  padding: 0;\n  line-height: 20px;\n  letter-spacing: 0;\n  color: var(--text-primary);\n  box-sizing: border-box;\n}\n\n.bs-container .bs-table tbody td.bs-table-label-cell {\n  text-align: left;\n  padding-left: 8px;\n  min-width: 180px;\n  max-width: 180px;\n}\n\n.bs-container .bs-table tbody td.bs-table-cell {\n  text-align: right;\n  padding: 0 8px 0 0;\n  min-width: 100px;\n  max-width: 100px;\n}\n\n.bs-label-with-icon {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n  user-select: none;\n}\n\n.bs-expand-icon {\n  width: 16px;\n  height: 16px;\n  transition: transform 0.2s ease;\n  transform: rotate(-90deg);\n  flex-shrink: 0;\n  color: var(--text-primary);\n  path {\n    fill: currentColor;\n  }\n}\n\n.bs-expand-icon.expanded {\n  transform: rotate(0deg);\n}\n\n.bs-label-text {\n  font-size: 16px;\n  line-height: 24px;\n  color: var(--text-primary);\n  font-weight: 700;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  display: block;\n  max-width: 100%;\n}\n\n.bs-indented-label {\n  font-size: 16px;\n  line-height: 24px;\n  padding-left: 32px !important;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.bs-cell-content {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  padding: 8px 0;\n}\n\n.bs-cell-value {\n  font-size: 16px;\n  line-height: 18px;\n  color: var(--text-primary);\n  height: 24px;\n}\n\n.bs-cell-growth {\n  font-size: 14px;\n  line-height: 100%;\n  font-weight: 400;\n  height: 16px;\n}\n\n.bs-cell-growth.positive {\n  color: var(--text-up-color);\n}\n\n.bs-cell-growth.negative {\n  color: var(--text-down-color);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
